import { CommonModule } from "@angular/common";
import { Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

export function convTo2Digits(val: any, to: number, def: any) {
  var myVal: any = null;
  if (typeof val === 'string') {
    myVal = parseInt(val, 10);
  } else if (typeof val === 'number') {
    myVal = val;
  }
  if (typeof myVal === 'number' && !isNaN(myVal)) {
    if (myVal < 0) {
      myVal = 0;
    }
    if (myVal > to) {
      myVal = to;
    }
    if (myVal < 10) {
      return "0" + myVal;
    }
    return "" + myVal;
  }
  return def;
}

function updatePositions(width: any) {
  let x = 0, y = 0, x2 = 0, y2 = 0, maxVal = 60, offset, m: any[] = [];
  var result: any = {
    mStyles: {},
    hStyles: {}
  };
  offset = width / 2 - 20;
  let middle = offset + 10;
  for (let v = 0; v < maxVal; v++) {
    middle = offset + 10;
    let o: any = {
      i: v,
      val: '',
    };
    let isDot = true;
    if (v % 5 === 0) {
      isDot = false;
      o.val = v === 0 ? '00' : '' + v;
    }
    x = 0;
    y = offset;
    let phi = -v * 2 * Math.PI / maxVal;
    x2 = x;
    y2 = y;

    if (v > 0) {
      if (isDot) {
        y = offset - 3;
      }
      x2 = x * Math.cos(phi) - y * Math.sin(phi);
      y2 = x * Math.sin(phi) + y * Math.cos(phi);
    }
    o.left = x2 + middle;
    o.top = -y2 + middle;
    o.x = o.left + 10;
    o.y = o.top + 10;
    if (isDot) {
      o.left += 10;
      o.top += 10;
    }
    m.push(o);
  }
  result.mStyles = m;
  console.log('Ms:', m);
  m = [];
  maxVal = 12;
  for (let v = 0; v < maxVal; v++) {
    middle = offset + 10;
    let o: any = {
      i: (v === 0) ? 12 : v,
    };

    x = 0;
    y = offset;
    let phi = -v * 2 * Math.PI / maxVal;
    x2 = x;
    y2 = y;

    if (v > 0) {
      x2 = x * Math.cos(phi) - y * Math.sin(phi);
      y2 = x * Math.sin(phi) + y * Math.cos(phi);
    }
    o.left = x2 + middle;
    o.top = -y2 + middle;
    o.x = o.left + 10;
    o.y = o.top + 10;

    o.val = '' + o.i;
    m.push(o);
  }
  var h: any[] = [];
  for (var i = 0; i < m.length; i++) {
    var o: any = {
      i: (m[i].i + 12) % 24
    };
    o.val = '' + o.i;
    if (o.i === 0) {
      o.val = '00';
    }
    o.left = (m[i].left - middle) * 0.66 + middle;
    o.top = (m[i].top - middle) * 0.66 + middle;
    o.x = o.left + 10;
    o.y = o.top + 10;
    h.push(o);
  }
  m = m.concat(h);
  result.hStyles = m;
  console.log('Hs:', m);
  return result;
}

@Component({
  selector: 'time-picker-dialog',
  templateUrl: 'time-picker-dialog.html',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
  ],
})
export class TimePickerDialog implements OnInit {
  animal: any;
  _hours = "00";
  _minutes = "00";
  _hoursView = true;

  tcs: string[] = ['hours-active', ''];

  cancelLabel = "Cancel";
  okLabel = "OK";

  hStyles: any[] = [];
  mStyles: any[] = [];
  version = 1;

  @ViewChild('content', { static: false, read: ElementRef }) elRef: any;

  mainStyle: any = {

  };

  constructor(
    public dialogRef: MatDialogRef<TimePickerDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.mainStyle.width = data.width + 'px';
    this.mainStyle.height = data.width + 'px';
    if (data.version) {
      this.version = data.version;
    }
    console.log('Version:', this.version);
  }

  updatePositions() {
    if (this.version == 1) {
      var res = updatePositions(this.data.width);
      this.hStyles = res.hStyles;
      this.mStyles = res.mStyles;

      return;
    }

    var vals: any[] = [];
    for (var i = 0; i < 24; i++) {
      var o: any = {
        v: i,
        l: i >= 6 && i < 18
      };
      vals.push(o);
    }
    this.hStyles = [
      vals.slice(0, 6),
      vals.slice(6, 12),
      vals.slice(12, 18),
      vals.slice(18),
    ];

    vals = [];
    for (var i = 0; i < 60; i += 5) {
      var o: any = {
        v: i,
        l: (i % 15 === 0)
      };
      vals.push(o);
    }
    this.mStyles = [
      vals.slice(0, 3),
      vals.slice(3, 6),
      vals.slice(6, 9),
      vals.slice(9),
    ];
  }

  onClick($event: any) {
    console.log('CLICK', $event);
    console.log('EL', this.elRef);
    //Prefer button clicks
    if (this.ocClick) {
      var curTime = new Date();
      if (curTime.getTime() - this.ocClick.getTime() < 500) {
        console.log('Ignore');
        return;
      }
    }
    if (this._hoursView) {
      console.log('Hsss!');
      return;
    }
    var forMin = true;

    if (this.elRef && this.elRef.nativeElement) {

      var offset = this.data.width / 2 + 10;
      var r = this.elRef.nativeElement.getBoundingClientRect();
      console.log('R:', r);
      var elems = forMin ? this.mStyles : this.hStyles,
        h = r.height / 2,
        x = $event.clientX - r.x,
        y = $event.clientY - r.y;
      var minDist = Math.sqrt(2) * h, hit = 0;

      for (var i = 0; i < elems.length; i++) {
        var e = elems[i];
        var dx = x - e.x;
        var dy = y - e.y;
        var d = Math.sqrt(dx * dx + dy * dy);
        if (minDist > d) {
          minDist = d;
          hit = i;
        }
      }
      x -= offset;
      y = -(y - offset);
      var l = Math.sqrt(x * x + y * y);
      if (l > 0) {

      }
      var phi = Math.acos(x / l);
      if (x > 0) {
        if (y < 0) {
          phi = Math.PI / 2 + (Math.PI / 2 - phi);
        }
      } else {
        if (y > 0) {
          phi = Math.PI / 2 + (Math.PI / 2 - phi);
        } else {

        }
        phi += Math.PI;
      }
      phi = -phi;
      var p = Math.floor((phi / (2 * Math.PI)) * 60) - 1;


      console.log("HIT:", x, y, phi, p, hit, elems[hit]);
      if (forMin) {
        this._minutes = convTo2Digits(hit, 59, this._minutes);
      } else {
        this._hours = convTo2Digits(hit, 23, this._hours);
      }
    }
  }
  ocClick?: Date;

  oc(val: any, isHour: boolean) {
    console.log('VAL:', val);

    this.ocClick = new Date();
    if (isHour) {
      this._hours = convTo2Digits(val, 23, this._hours);
      this._hoursView = false;
    } else {
      this._minutes = convTo2Digits(val, 59, this._minutes);
    }
    this.updateTop();
  }

  ngOnInit() {
    console.log('DATA:', this.data);
    this.updatePositions();

    if (this.data.okLabel) {
      this.okLabel = this.data.okLabel;
    }
    if (this.data.cancelLabel) {
      this.cancelLabel = this.data.cancelLabel;
    }
    let assigned = false;
    if (this.data.time) {
      if (this.data.time.h) {
        this._hours = convTo2Digits(this.data.time.h, 23, this._hours);
        assigned = true;
      }
      if (this.data.time.m) {
        this._minutes = convTo2Digits(this.data.time.m, 59, this._minutes);
        assigned = true;
      }
    }

    if (this.data.value && (this.data.value instanceof Date)) {
      this.setByDate(this.data.value)
      assigned = true;
    }

    if (!assigned) {
      this.setByDate(new Date());
    }
  }
  setByDate(date: Date) {
    console.log('Date', date);

    let h = date.getHours(),
      m = date.getMinutes();

    this._hours = convTo2Digits(h, 23, this._hours);
    this._minutes = convTo2Digits(m, 59, this._minutes);
  }

  updateTop() {
    this.tcs = this._hoursView ? ['hours-active', ''] : ['', 'minutes-active'];
  }

  tc(hoursClick: boolean) {
    console.log('CLICK:HOURS?', hoursClick);

    this._hoursView = hoursClick;

    this.updateTop();
  }

  onClose(yes: boolean) {
    let result: any;
    if (yes) {
      result = new Date();
      result.setHours(parseInt(this._hours, 10), parseInt(this._minutes, 10), 1);
    }
    this.dialogRef.close(result);
  }
}
